import { matchPath } from 'react-router-dom'

const BUDGET_ROLES = ['admin', 'accountant', 'department_head', 'management']

const hasPermission = (user, permission) => user?.permissions?.[permission] === true

const ROUTE_ACCESS_RULES = [
  { path: '/admin/sync/mapping', canAccess: () => false },
  { path: '/admin/sync-settings', canAccess: () => false },
  { path: '/admin/reference', canAccess: (user) => user?.role === 'admin' && hasPermission(user, 'reference.view') },
  { path: '/admin/custom-fields', canAccess: (user) => user?.role === 'admin' && hasPermission(user, 'custom_fields.view') },
  { path: '/admin/deleted-records', canAccess: (user) => hasPermission(user, 'deleted_records.view') },
  { path: '/admin/sync', canAccess: () => false },
  { path: '/admin/roles', canAccess: (user) => user?.role === 'admin' && hasPermission(user, 'roles.view') },
  { path: '/admin/users/new', canAccess: (user) => user?.role === 'department_head' || hasPermission(user, 'users.view') },
  { path: '/admin/users/:id/edit', canAccess: (user) => user?.role === 'department_head' || hasPermission(user, 'users.view') },
  { path: '/admin/users', canAccess: (user) => user?.role === 'department_head' || hasPermission(user, 'users.view') },
  { path: '/admin/system-params', canAccess: (user) => ['admin', 'management'].includes(user?.role) || hasPermission(user, 'settings.system_params') },
  { path: '/admin/bot-response-rules', canAccess: (user) => ['admin', 'management'].includes(user?.role) || hasPermission(user, 'settings.system_params') },
  { path: '/company/reports', canAccess: (user) => hasPermission(user, 'reports.view') },
  { path: '/company/reports/:id', canAccess: (user) => hasPermission(user, 'reports.view') },
  { path: '/company/reports/:id/config', canAccess: (user) => hasPermission(user, 'reports.view') },
  { path: '/company/reports/:id/accountant', canAccess: (user) => hasPermission(user, 'reports.view') },
  { path: '/company/team/income-report', canAccess: (user) => hasPermission(user, 'reports.view') },
  { path: '/stage/:id/income-report', canAccess: (user) => hasPermission(user, 'stages.view') },
  { path: '/company/stages/summary-report', canAccess: (user) => hasPermission(user, 'stages.view') },
  { path: '/admin/budget/*', canAccess: (user) => BUDGET_ROLES.includes(user?.role) },
  { path: '/admin/*', canAccess: (user) => ['admin', 'management', 'department_head'].includes(user?.role) }
]

export function canAccessRoute(pathname, user) {
  const matchedRule = ROUTE_ACCESS_RULES.find((rule) => matchPath({ path: rule.path, end: true }, pathname))
  if (!matchedRule) {
    return true
  }
  return matchedRule.canAccess(user)
}
